import { ADD_AGGREGATION_COUNTS, SET_AGGREGATION_COUNTS_LOADING } from '@Actions/aggregationCountsActions';
export const defaultState = {
    aggregationCounts: {},
    aggregationCountsLoading: {}
};
export default function (state = defaultState, action) {
    switch (action.type) {
        case ADD_AGGREGATION_COUNTS:
            return Object.assign(Object.assign({}, state), { aggregationCounts: Object.assign(Object.assign({}, state.aggregationCounts), { [action.payload.match]: action.payload.aggregationCounts }) });
        case SET_AGGREGATION_COUNTS_LOADING:
            return Object.assign(Object.assign({}, state), { aggregationCountsLoading: Object.assign(Object.assign({}, state.aggregationCountsLoading), { [action.payload.match]: action.payload.loading }) });
        default:
            return state;
    }
}
